/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Share_Lpusers2Inputs */

const en_coinvestments_share_lpusers2 = /** @type {(inputs: Coinvestments_Share_Lpusers2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lpName} users`)
};

/**
* | output |
* | --- |
* | "{lpName} users" |
*
* @param {Coinvestments_Share_Lpusers2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_lpusers2 = /** @type {((inputs: Coinvestments_Share_Lpusers2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Lpusers2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_lpusers2(inputs)
});
export { coinvestments_share_lpusers2 as "coInvestments_share_lpUsers" }